export default "__VITE_ASSET__J5qnutJ0__$_?url__"